import Vue from 'vue'
import {
  Menu,
} from 'floating-vue'
import 'floating-vue/dist/style.css'

Vue.component('VMenu', Menu)
